import { API } from "../../utils/SchedulerAPIUtils";
import { setAuthHeader } from '../../utils/SchedulerAPIUtils';


// Professional Events API Helpers
export const getProfessionalEventsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.get(`/api/v1/meetings/interviews-by-email`, {
      params,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postProfessionalEventsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.post(`/api/v1/meetings/add`, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updateProfessionalEventsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.patch(
      `/api/v1/meetings/${payload?.id}?type=${payload?.type}`,
      payload,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deleteProfessionalEventsAPIHelper = async (id) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.delete(`/api/meetings/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

// Personal Events API Helpers
export const getPersonalEventsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.get(`/api/personal-events`, {params});
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const postPersonalEventsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.post(`/api/personal-events/add`, payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const updatePersonalEventsAPIHelper = async (payload) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.patch(
      `/api/personal-events/${payload?.id}?type=${payload?.type}`,
      payload,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const deletePersonalEventsAPIHelper = async (id) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.delete(`/api/personal-events/${id}`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};


export const getCompanyEventsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.get(`/api/v2/events`, {params});
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getBusyEventsAPIHelper = async (params) => {
  try {
    const token = localStorage.getItem('objectId');
    // Set auth header with token
    setAuthHeader(token);

    const response = await API.get(`/api/v2/events/interviews-by-emails`, {params});
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

